import { createSvgComponent } from "../../icon/createSvgComponent";
import WelloHelperMark from "@core/icon/assets/wello-helper-mark.svg";
export default createSvgComponent(WelloHelperMark);